import { useState } from 'react';
import { Button, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { LibraryBooks } from '@mui/icons-material';
import CameraSelection from '../CameraSelection';
import PdfDialog from './PdfDialog';

export default function Report({ loading, disabled, fileExists, alertMessage, filePath, targetFilename, cameraId, setCameraId, availableCameras }) {
    
    const { CAMERAS } = window.conf;
    const { t } = useTranslation();

    const [openDialog, setOpenDialog] = useState(false);

    const moreThanOneCam = CAMERAS.length > 1

    const onOpenDialog = () => {
        setOpenDialog(true)
    }

    return (
        <>
            <Box sx={{ width: "100%", display: "flex", flexDirection: "column" }}>

                {moreThanOneCam && (
                    <CameraSelection
                        value={cameraId}
                        onChange={setCameraId}
                        availableCameras={availableCameras}
                    />
                )}

                <Box component="span">
                    <Button
                        onClick={onOpenDialog}
                        startIcon={<LibraryBooks />}
                        disabled={loading || disabled}
                        variant="contained"
                        size='large'
                        fullWidth
                    >
                        {t("actions.create")}
                    </Button>
                </Box>

            </Box>

            <PdfDialog
                open={openDialog}
                setOpen={setOpenDialog}
                alertMessage={alertMessage}
                fileExists={fileExists}
                filePath={filePath}
                targetFilename={targetFilename}
            />
        </>
    )
}